// Client wrapper around POST /.netlify/functions/send-invoice.
//
// The server does everything real — this file just packages the fetch call
// and forwards the current user's access token so the Netlify Function can
// verify is_admin() with the caller's own JWT.

import { supabase } from './supabase'

export async function sendInvoice(orderId) {
  if (!orderId) throw new Error('order_id missing')

  const { data: { session } } = await supabase.auth.getSession()
  const token = session?.access_token
  if (!token) throw new Error('Not signed in')

  const res = await fetch('/.netlify/functions/send-invoice', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ order_id: orderId }),
  })

  let data = null
  try { data = await res.json() } catch { /* body may be empty */ }

  if (!res.ok) {
    throw new Error(data?.error || `Send invoice failed (${res.status})`)
  }
  return data // { stripe_invoice_id, hosted_invoice_url, reused? }
}
